<template>
	<div>
		<PageHeader title="Alapanyagok" button_title="Új alapanyag rögzítése" button_href="/materials/create" />
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox">
						<div class="ibox-content">
							<div class="row" v-if="materials === false">
								<div class="col-12 text-center">
									<h3>Alapanyagok betöltése</h3>
									<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
								</div>
							</div>
							<div class="widget p-lg text-center" v-if="materials.length == 0">
								<div class="m-b-md">
									<i class="fa fa-balance-scale fa-4x"></i>
									<h1 class="m-xs"><i class="fa fa-times"></i></h1>
									<h3 class="font-bold no-margins">
										Nincsenek Alapanyagok
									</h3>
									<small>Hozzon létre alapanyagot</small>
								</div>
							</div>
							<div class="table-responsive" v-if="materials.length != 0 && materials !== false">
								<vue-good-table
									styleClass="vgt-table striped w-100" 
									rowStyleClass="fs-12"
									:columns="columns" 
									:rows="materials" 
									:pagination-options="this.$vueGTPaginationOptions" 
									:fixed-header="true"
								>
									<template slot="table-row" slot-scope="props">										
										<span v-if="props.column.field == 'actions'">											
											<router-link :to="'materials/'+props.row.id+'/edit'" class="btn btn-success mx-1 d-inline" title="szerkesztés"><i class="fa fa-pencil-alt"></i></router-link>
											<router-link :to="'material_containers/'+props.row.id+'/create'" class="btn btn-success mx-1 d-inline" title="készlet" v-if="$root.$data.user.role_id != 3"><i class="fa fa-cubes"></i></router-link>
											<button class="btn btn-danger mx-1 d-inline" @click="deleteMaterial(props.row.id)" title="törlés"><i class="fa fa-trash"></i></button>
										</span>
										<span v-else-if="props.column.field == 'production_treshold'">
											<i class="fa fa-exclamation-triangle text-danger mr-4 fa-2x" title="hiányzó gyártási tűrés" v-if="props.row.production_treshold == 0"></i>
											<span v-else>{{ props.row.production_treshold }} %</span>
										</span>
										<span v-else-if="props.column.field == 'quantity'">
											{{ props.row.quantity }} {{ props.row.unit }}
										</span>
										<span v-else>
											{{props.formattedRow[props.column.field]}}
										</span>
									</template>
								</vue-good-table>							
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '../../components/PageHeader';
import Material from "../../apis/Material";
export default {
    components: { PageHeader },
    data() {
        return {
            materials: false,
			columns:[
				{
					label:'Megnevezés',
					field:'name',
					filterOptions : {
						enabled:true,
						placeholder: 'Keresés',
					},
					thClass: 'fs-12'
				},
				{
					label:'INCI',
					field:'inci',
					filterOptions : {
						enabled:true,
						placeholder: 'Keresés',
					},
					thClass: 'fs-12'
				},
				{
					label:'Aktuális készlet',
					field:'quantity',
					filterOptions : {
						enabled:false
					},
					thClass: 'fs-12',
					tdClass: 'text-right'
				},
				{
					label:'Gyártási tűrés',
					field:'production_treshold',
					thClass: 'fs-12',
					tdClass: 'text-right',
					sortFn: (a, b) => {
						if (a < b) return -1;
						if (a > b) return 1;
						return 0;
					}
				},
				{
					label:'Raktári hely',
					field:'storage_place_name',
					filterOptions : {
						enabled:true,
						placeholder: 'Keresés',
					},
					thClass: 'fs-12'
				},
				{
					label: 'Műveletek',
					field: 'actions',
					width: '15%',
					sortable: false,
					thClass: 'text-right fs-12',
					tdClass: 'text-right'
				}
			]
        }
    },	
    created() {
        Material.index()
				.then(response => {
					this.materials = response.data;
				})

    },
    methods: {
			deleteMaterial(id) { 
				this.$confirm({
					message: `Biztos törlöd ezt az alapanyagot?`,
					button: {
						no: 'Nem',
						yes: 'Igen'
					},
					/**
					* Callback Function
					* @param {Boolean} confirm
					*/
					callback: confirm => {
						if (confirm) {
							Material.delete(id)
							.then(() => {
								let i = this.materials.map(data => data.id).indexOf(id);
								this.materials.splice(i, 1)
							})
							.catch(error => {
									this.errors = error.response.data.errors;
							})
						}
					}
				})
			}
    }
};
</script>

<style>
</style>